import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={15}
    height={11}
    viewBox="0 0 15 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.1938 10.3266C14.2178 10.2801 14.2303 10.2286 14.2303 10.1762C14.2302 10.111 14.2104 10.0472 14.1734 9.9934L7.72792 0.639472C7.66773 0.552159 7.56851 0.5 7.46239 0.5C7.35636 0.5 7.25705 0.552159 7.19685 0.639472L0.740683 9.9934C0.672459 10.093 0.665371 10.2225 0.722351 10.3289C0.779331 10.4354 0.890832 10.5014 1.0116 10.5H13.908C14.0281 10.5 14.1382 10.4332 14.1938 10.3266L14.1938 10.3266Z"
      fill="black"
    />
  </svg>
);
export default SVGComponent;
